import React, { useEffect, useState } from "react";
import { Pagination, Spin, Table, Tag, Tooltip, Drawer, Avatar } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  getExpertrecords,
  getExpertRecordsCount,
  getKeyTag,
  getRerouteUser,
} from "../../API/api";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action/index";
import moment from "moment";
import { convertEpochToTimestamp } from "../../utils";
import Styles from "./ExpertRecordsStyles.module.css";
import { CloseCircleOutlined } from "@ant-design/icons";
import { ReactComponent as DownloadIcon } from "../../Icons/download.svg";
import Button2 from "../../NewComponent/Button2/Button2";
import {
  SearchOutlined,
  SyncOutlined,
  DownloadOutlined,
  PlusOutlined,
  DeleteOutlined,
  ReloadOutlined,
  FileExcelOutlined,
  RetweetOutlined,
  FilterOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import ExpertRecordsFilters from "./ExpertRecordsFilters";
import { BASE_URL, currentGroup } from "../../API/url";
import { toast } from "react-toastify";
import IosShareIcon from "@mui/icons-material/IosShare";
import FilterListIcon from "@mui/icons-material/FilterList";
import DeleteIcon from "@mui/icons-material/Delete";
import { AutoComplete, Input } from "antd";
import { ReactComponent as SearchButtonIcon } from "./../../Icons/searchButton.svg";
import { ReactComponent as SearchFilterIcon } from "./../../Icons/searchFilter.svg";
import { ReactComponent as UploadQIcon } from "./../../Icons/uploadQ.svg";
import { ReactComponent as CrossIcon } from "./../../Icons/cross.svg";
import { ReactComponent as BookIcon } from "./../../Icons/Icon.svg";
// import { ReactComponent as RefreshIcon } from "../../Icons/refresh.svg";
import { ReactComponent as ShareIcon } from "../../Icons/share.svg";
import { ReactComponent as DeleteIcons } from "../../Icons/delete.svg";
import { ReactComponent as UploadIcon } from "../../Icons/upload-cloud-02.svg";
// import ExpertIcon from '../../Icons/export.png'
import TabSearch from "../../NewComponent/TabSearch/tabSearch";
import TooltipComp from "../../NewComponent/ToolTip/TooltipComp";
import { ReactComponent as FireIcon } from "./../../Icons/fire.svg";
import uploadImage from "../../Icons/upload-cloud-02.svg";
import TagComp from "../../NewComponent/Tag/TagComp";

const momentit = (stime) => {
  if (Number(Date.now()) - Number(stime) < 259200000) {
    return moment(new Date(Number(stime))).fromNow();
  } else {
    return moment(convertEpochToTimestamp(stime)).format("ll");
  }
};
const textStyles = {
  fontSize: "16px",
  color: "#2A364A",
  lineHeight: "24px",
  fontWeight: "500",
  // wordBreak: "break-word",
};
const ExpertRecordsTable = () => {
  const navigate = useNavigate();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [open, setOpen] = useState(false);
  const domainState = useSelector((state) => state.cmRoot);
  const expertRecordsState = useSelector((state) => state.expertRecord);
  const dispatch = useDispatch();
  const {
    cmrTotalCount,
    cmrUpdateData,
    cmrUpdatePageNo,
    cmrUpdatePage,
    cmrRefreshPage,
    cmrTabSearchData,
    cmrUpdateFilters,
    advanceFilterModalToggle,
    cmrClickedData,
    cmrIsBackFromEmailLink,
    cmrExpertsList,
    getSeekerAttachmentsForExpertRecords,
  } = bindActionCreators(Actions, dispatch);

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = (data) => {
    setOpen(false);
    cmrUpdateFilters(data);
  };

  const downloadData = () => {
    if (expertRecordsState.totalCount * 2 > 200) {
      toast.warning(() => {
        return (
          <>
            <span style={{ fontSize: "12px" }}>
              Results exceed 200 rows. Please apply filters.
            </span>
          </>
        );
      });
      return;
    }
    let baseUrl = `${BASE_URL}/cmuser/group/${currentGroup}/dataexport?type=expertrecords&levelid=${
      domainState.selecetdRoutingValue
    }&levelvalue=${
      domainState.selectedGeoLevel.length === 0
        ? ""
        : domainState.selectedGeoLevel.value
    }&showanswer=false&domains=${domainState.selectedDomainIds}&timezone=${
      Intl.DateTimeFormat().resolvedOptions().timeZone
    }`;
    if (expertRecordsState.seekers.length > 0) {
      baseUrl +=
        "&seekers=" +
        expertRecordsState.seekers.map((sk) => sk?.userUuid).toString();
    }
    if (expertRecordsState.experts.length > 0) {
      baseUrl +=
        "&experts=" +
        expertRecordsState.experts.map((sk) => sk?.userUuid).toString();
    }
    //     if(spilled) {
    //         callingAPI += '&spilled='+spilled;
    //     }
    if (expertRecordsState.excludeEmail) {
      baseUrl += "&excludeEmail=" + expertRecordsState.excludeEmail;
    }
    if (expertRecordsState.urgent) {
      baseUrl += "&express=" + expertRecordsState.urgent;
    }
    if (!Array.isArray(expertRecordsState.status)) {
      baseUrl += "&status=" + expertRecordsState.status.name;
    }
    if (!Array.isArray(expertRecordsState.rating)) {
      baseUrl += "&rating=" + expertRecordsState.rating.name;
    }
    if (expertRecordsState.nonCurated) {
      if (expertRecordsState.curatedFromDate !== "") {
        baseUrl +=
          "&updatedFrom=" +
          Date.parse(new Date(expertRecordsState.curatedFromDate));
      }
      if (expertRecordsState.curatedToDate !== "") {
        baseUrl +=
          "&updatedTo=" +
          Date.parse(new Date(expertRecordsState.curatedToDate));
      }
      if (!Array.isArray(expertRecordsState.curatedBy)) {
        baseUrl += "&curatedby=" + expertRecordsState.curatedBy;
      }
    }
    if (expertRecordsState.fromDate !== "") {
      baseUrl +=
        "&startDate=" + Date.parse(new Date(expertRecordsState.fromDate));
    }
    if (expertRecordsState.tillDate !== "") {
      baseUrl +=
        "&endDate=" + Date.parse(new Date(expertRecordsState.tillDate));
    }

    if (expertRecordsState.cc.length > 0) {
      baseUrl +=
        "&curationcategory=" +
        expertRecordsState.cc.map((cc) => cc.name).toString();
    }
    if (expertRecordsState.cs.length > 0) {
      baseUrl +=
        "&curationcategory=" +
        expertRecordsState.cs.map((cs) => cs.name).toString();
    }
    window.open(baseUrl, "_blank");
    return;
  };
  const firstColumn = () => {
    return (
      <>
        {/* <Input
          placeholder="Search"
          allowClear
          size="small"
          value={expertRecordsState.tabsearch}
          onChange={(e) => onChangeText(e)}
          prefix={<SearchOutlined />}
        /> */}
        <span style={textStyles}>Seeker Name</span>
      </>
    );
  };
  const ExtraColumn = () => {
    return (
      <>
        {/* <Input
          placeholder="Search"
          allowClear
          size="small"
          value={expertRecordsState.tabsearch}
          onChange={(e) => onChangeText(e)}
          prefix={<SearchOutlined />}
        /> */}
        <span style={textStyles}>Domain</span>
      </>
    );
  };
  const secondColumn = () => {
    return <span style={textStyles}>Seeker Question</span>;
  };
  const onCLickDeleteIcon = () => {
    cmrClickedData(selectedRowKeys);
    advanceFilterModalToggle({ bool: true, value: "deleteexpertrecords" });
  };
  const onCLicktransferIcon = () => {
    cmrClickedData(selectedRowKeys);
    advanceFilterModalToggle({ bool: true, value: "townershipBulk" });
  };
  const onCLickRouteBackIcon = () => {
    cmrClickedData(selectedRowKeys);
    advanceFilterModalToggle({ bool: true, value: "routebacktoexpertbulk" });
  };
  const onCLickCreateQAIcon = () => {
    advanceFilterModalToggle({ bool: true, value: "createqapairexpertrecord" });
  };
  const thirdColumn = () => {
    return (
      <>
        <div style={{ display: "flex", alignItems: "center" }}>
          <span style={textStyles}>Date Asked</span>
        </div>
      </>
    );
  };
  const fetchImage = (key) => {
    switch (key) {
      case "csv":
        return (
          <>
            <Tooltip
              placement="bottom"
              title={() => (
                <span style={{ color: "black", fontSize: "10px" }}>
                  User added QA via XLS Atomizer
                </span>
              )}
              color="#fff"
            >
              <i
                className="fa fa-file-excel-o"
                style={{ fontSize: "14px", color: "purple" }}
              ></i>
            </Tooltip>
          </>
        );
      case "expert-QA":
        return (
          <>
            <Tooltip
              placement="bottom"
              title={() => (
                <span style={{ color: "black", fontSize: "10px" }}>
                  User added QA via Expert role
                </span>
              )}
              color="#fff"
            >
              <i
                className="fa fa-user-plus"
                style={{ fontSize: "14px", color: "#fb7432" }}
              ></i>
            </Tooltip>
          </>
        );
      case "msteams":
        return (
          <>
            <Tooltip
              placement="bottom"
              title={() => (
                <span style={{ color: "black", fontSize: "10px" }}>
                  User asked a question via MS Teams
                </span>
              )}
              color="#fff"
            >
              <img
                src={require("../../Images/msteams.ico")}
                style={{ width: "16px" }}
              />
            </Tooltip>
          </>
        );
      case "msteams-channel":
        return (
          <>
            <Tooltip
              placement="bottom"
              title={() => (
                <span style={{ color: "black", fontSize: "10px" }}>
                  User asked a question via MS Teams channel
                </span>
              )}
              color="#fff"
            >
              <img
                src={require("../../Images/msteams.ico")}
                style={{ width: "16px" }}
              />
            </Tooltip>
          </>
        );
      case "webex":
        return (
          <>
            <Tooltip
              placement="bottom"
              title={() => (
                <span style={{ color: "black", fontSize: "10px" }}>
                  User asked a question via Webex
                </span>
              )}
              color="#fff"
            >
              <img
                src={require("../../Images/webex.jpg")}
                style={{ width: "16px" }}
              />
            </Tooltip>
          </>
        );
      case "webex-channel":
        return (
          <>
            <Tooltip
              placement="bottom"
              title={() => (
                <span style={{ color: "black", fontSize: "10px" }}>
                  User asked a question via Webex channel
                </span>
              )}
              color="#fff"
            >
              <img
                src={require("../../Images/webex.jpg")}
                style={{ width: "16px" }}
              />
            </Tooltip>
          </>
        );
      case "Mobile":
        return (
          <>
            <Tooltip
              placement="bottom"
              title={() => (
                <span style={{ color: "black", fontSize: "10px" }}>
                  User searched via Mobile Application
                </span>
              )}
              color="#fff"
            >
              <img
                src={require("../../Images/32x32.png")}
                style={{ width: "16px" }}
              />
            </Tooltip>
          </>
        );
      case "slack":
        return (
          <>
            <Tooltip
              placement="bottom"
              title={() => (
                <span style={{ color: "black", fontSize: "10px" }}>
                  User asked a question via Slack Vizerto bot
                </span>
              )}
              color="#fff"
            >
              <img
                src={require("../../Images/slack.png")}
                style={{ width: "16px" }}
              />
            </Tooltip>
          </>
        );
      case "slack-channel":
        return (
          <>
            <Tooltip
              placement="bottom"
              title={() => (
                <span style={{ color: "black", fontSize: "10px" }}>
                  User asked a question on slack channel
                </span>
              )}
              color="#fff"
            >
              <img
                src={require("../../Images/slack.png")}
                style={{ width: "16px" }}
              />
            </Tooltip>
          </>
        );
      default:
        return <span>{key}</span>;
    }
  };
  const openDetailedPage = (obj) => {
    cmrClickedData(obj);
    getKeyTag([obj.questionUuid]);
    // getExpertRecordKeyTag
    if (obj.fileNames) {
      getSeekerAttachmentsForExpertRecords(obj.fileNames);
    }
    navigate(
      `/cmHome/expertrecordDetail/${btoa(obj.questionUuid)}/${btoa(
        obj.userType,
      )}`,
    );
  };

  const columns = [
    {
      title: firstColumn(),
      dataIndex: "seekerName",
      width: "10%",
      render: (_, raw) => {
        const nameParts = raw.seekerName?.split(" ") || [];
        return (
          <div className={Styles.textSize}>
            {nameParts.map((part, index) => (
              <div key={index}>{part}</div>
            ))}
          </div>
        );
      },
    },
    // {
    //   title: ExtraColumn(),
    //   dataIndex: "column",
    //   width: "13%",
    //   render: (_, raw) => (
    //     <>
    //       {/* <div>
    //         <span className={Styles.textSize}>{raw.seekerName}</span>
    //       </div> */}
    //    <TagCompDomain key={raw.domain} title={raw.domain}  />
    //     </>
    //   ),
    // },
    {
      title: secondColumn(),
      dataIndex: "questionText",
      width: "68%",
      render: (_, raw) => (
        <>
          <div
            style={{ cursor: "pointer" }}
            onClick={() => openDetailedPage(raw)}
          >
            <div style={{ display: "flex" }}>
              {raw.express && (
                // <Tooltip placement="top"
                //   color="#fff"
                //   title={() => (
                //     <span style={{ color: "black", fontSize: "11px" }}>
                //       This is an urgent question.
                //     </span>
                //   )}>
                //   <span>
                //     <img
                //       style={{ width: "16px" }}
                //       src={require("../../Images/fire.png")}
                //     />
                //     &nbsp;
                //   </span>
                // </Tooltip>
                <TooltipComp title="This is an urgent question">
                  <Avatar
                    shape="round"
                    icon={
                      <FireIcon style={{ fontSize: "12px", color: "red" }} />
                    }
                    style={{
                      marginBottom: "2px",
                      backgroundColor: "transparent", // key to inheriting parent bg
                      boxShadow: "none", // remove any shadow
                    }}
                  />
                </TooltipComp>
              )}
              <span className={Styles.textSize}>
                <span
                  style={{ color: "#00A5FB", fontSize: "16px" }}
                  className={Styles.questionText}
                >
                  {raw.questionText}
                </span>
                &nbsp;
                {raw.clarifications !== undefined && (
                  <TooltipComp
                    title={
                      raw.clarifications[0].status === "wip"
                        ? "Clarification Pending"
                        : "Clarification Received"
                    }
                  >
                    <i
                      className="fa fa-question-circle"
                      style={{
                        color: `${
                          raw.clarifications[0].status !== "wip"
                            ? "green"
                            : "#fd7400"
                        }`,
                        cursor: "pointer",
                      }}
                    ></i>
                  </TooltipComp>
                  // <Tooltip
                  //   placement="top"
                  //   color="#fff"
                  //   title={() => (
                  //     <span style={{ color: "black", fontSize: "11px" }}>
                  //       {raw.clarifications[0].status === 'wip'
                  //         ? "Clarification Pending"
                  //         : "Clarification Received"}
                  //     </span>
                  //   )}
                  // >
                  // <i
                  //   className="fa fa-question-circle"
                  //   style={{
                  //     color: `${raw.clarifications[0].status !== 'wip' ? "green" : "#fd7400"
                  //       }`,
                  //     cursor: "pointer",
                  //   }}
                  // ></i>
                  // </Tooltip>
                )}
              </span>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              {raw.domain && (
                <Tag
                  style={{
                    fontSize: "11px",
                    backgroundImage:
                      "linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)",
                    border: "none",
                    color: "#fff",
                    borderRadius: "4px",
                    padding: "0 8px",
                    height: "20px", // match AntD default Tag height
                    display: "inline-flex",
                    alignItems: "center", // vertical-center text
                    whiteSpace: "nowrap",
                  }}
                >
                  {raw.domain}
                </Tag>
              )}

              {raw.forVerification && (
                <Tag color="#38c1c8" style={{ fontSize: "11px" }}>
                  Verify Answer
                </Tag>
              )}

              {raw.userInitiatedCuration && (
                <Tag color="#6c94ba" style={{ fontSize: "11px" }}>
                  Requested Update
                </Tag>
              )}
              {raw.answeredCount !== 0 && (
                <Tag color="#5d995d" style={{ fontSize: "11px" }}>
                  {raw.answeredCount} Answered
                </Tag>
              )}
              {!raw.forVerification &&
                raw.answeredCount === 0 &&
                raw.lifeOver && (
                  <Tag color="#ba6b69" style={{ fontSize: "11px" }}>
                    Expired
                  </Tag>
                )}
              {raw.openCount !== 0 && (
                <Tag color="#3086ba" style={{ fontSize: "11px" }}>
                  {raw.openCount} Open
                </Tag>
              )}
              {raw.rejectedCount !== 0 && (
                <Tag color="#987f77" style={{ fontSize: "11px" }}>
                  {raw.rejectedCount} Rejected
                </Tag>
              )}
              {raw.acceptedCount !== 0 && (
                <Tag color="lime" style={{ fontSize: "11px" }}>
                  {raw.acceptedCount} Accepted
                </Tag>
              )}
            </div>
          </div>
        </>
      ),
    },
    {
      title: thirdColumn(),
      dataIndex: "expertName",
      width: "100%",
      render: (_, raw) => (
        <>
          <div
            style={{
              fontSize: "13px",
              color: "#2A364A",
              fontWeight: "400",
              display: "flex",
            }}
          >
            Asked {momentit(raw.postedDate)}{" "}
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              gap: "6px",
            }}
          >
            {raw.lastUpdatedBy === undefined && raw.expertName && (
              <div
                style={{
                  fontSize: "13px",
                  color: "#2A364A",
                  fontWeight: "300",
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                }}
              >
                <div>
                  {raw.source !== "Vizerto" && (
                    <div
                      style={{
                        fontSize: "13px",
                        color: "#2A364A",
                        fontWeight: "400",
                        paddingLeft: "2px",
                        display: "flex",
                        alignItems: "center",
                        marginRight: "4px",
                      }}
                    >
                      <span>Via {fetchImage(raw.source)} ,</span>
                    </div>
                  )}
                </div>
                Answered by
                <span
                  style={{
                    color: "var(--light_color_shade)",
                    fontSize: "12px",
                    fontWeight: "bold",
                  }}
                >
                  {raw.expertName}
                </span>
              </div>
            )}

            {raw.lastUpdatedBy !== undefined && (
              <div
                style={{
                  fontSize: "13px",
                  color: "#2A364A",
                  fontWeight: "300",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  flexWrap: "wrap",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: "13px",
                    fontWeight: "300",
                    flexWrap: "wrap",
                  }}
                >
                  <div>
                    {raw.source !== "Vizerto" && (
                      <div
                        style={{
                          fontSize: "13px",
                          color: "#2A364A",
                          fontWeight: "400",
                          paddingLeft: "2px",
                          display: "flex",
                          alignItems: "center",
                          marginRight: "4px",
                        }}
                      >
                        <span>Via {fetchImage(raw.source)} ,</span>
                      </div>
                    )}
                  </div>
                  Last Updated {momentit(raw.latestAnswerUpdatedTime)}
                  <span style={{ whiteSpace: "nowrap", paddingLeft: "3px" }}>
                    By&nbsp;
                    <span
                      style={{
                        color: "#2A364A",
                        fontWeight: "600",
                      }}
                    >
                      {raw.lastUpdatedBy}
                    </span>
                  </span>
                </div>
              </div>
            )}
          </div>
        </>
      ),
    },
  ];
  const convertIntoEpoch = (time, key) => {
    let interval = 1000 * 60 * 60 * 24 - 1;
    let epochTime = "";
    if (key === "from") {
      let date = new Date(time);
      date.setHours(0, 0, 0, 0);
      epochTime = date.getTime();
    }
    if (key === "to") {
      let date = new Date(time);
      date.setHours(0, 0, 0, 0);
      epochTime = date.getTime() + interval;
    }
    return epochTime;
  };

  const fetchExpertRecordsCount = () => {
    if (expertRecordsState.tabsearch !== "") {
      setSelectedRowKeys([]);

      // cmrUpdatePage(true);
      let obj = {
        page: parseInt(expertRecordsState.pageNo) - 1,
        geoLevelId: domainState.selecetdRoutingValue,
        geoLevelValue:
          domainState.selectedGeoLevel.length === 0
            ? ""
            : domainState.selectedGeoLevel.value,
        domains: domainState.selectedDomainIds,
        excludeEmail:
          expertRecordsState.excludeEmail === true
            ? expertRecordsState.excludeEmail
            : undefined,
        nonCurated:
          expertRecordsState.nonCurated === true
            ? expertRecordsState.nonCurated
            : undefined,
        searchText: expertRecordsState.tabsearch,
        status: Array.isArray(expertRecordsState.status)
          ? undefined
          : expertRecordsState.status.name,
        rating: Array.isArray(expertRecordsState.rating)
          ? undefined
          : expertRecordsState.rating.name,
        curationCategory:
          expertRecordsState.cc.length === 0
            ? undefined
            : expertRecordsState.cc.map((cc) => cc.name).toString(),
        curationStatus:
          expertRecordsState.cs.length === 0
            ? undefined
            : expertRecordsState.cs.map((cs) => cs.name).toString(),
        express: expertRecordsState.urgent ? true : undefined,
        curatedby: Array.isArray(expertRecordsState.curatedBy)
          ? undefined
          : expertRecordsState.curatedBy,
        updatedFromDate:
          expertRecordsState.curatedFromDate === ""
            ? undefined
            : convertIntoEpoch(expertRecordsState.curatedFromDate, "from"),
        updatedToDate:
          expertRecordsState.curatedToDate === ""
            ? undefined
            : convertIntoEpoch(expertRecordsState.curatedToDate, "to"),
        fromDate:
          expertRecordsState.fromDate === ""
            ? undefined
            : convertIntoEpoch(expertRecordsState.fromDate, "from"),
        tillDate:
          expertRecordsState.tillDate === ""
            ? undefined
            : convertIntoEpoch(expertRecordsState.tillDate, "to"),
        seekers:
          expertRecordsState.seekers.length === 0
            ? undefined
            : expertRecordsState.seekers.map((id) => id.userUuid).toString(),
        experts:
          expertRecordsState.experts.length === 0
            ? undefined
            : expertRecordsState.experts.map((id) => id.userUuid).toString(),
        seekerType: expertRecordsState.seekerType,
        spilled:
          expertRecordsState.spill === true
            ? expertRecordsState.spill
            : undefined,
      };
      if (obj.geoLevelId !== "") {
        getExpertrecords(obj).then((res) => {
          if (res === undefined) return;
          cmrUpdateData(res.data.data);
          cmrIsBackFromEmailLink(false);
        });
      } else {
        cmrUpdatePage(false);
      }
    } else {
      setSelectedRowKeys([]);
      cmrUpdatePage(true);
      let obj = {
        page: parseInt(expertRecordsState.pageNo) - 1,
        geoLevelId: domainState.selecetdRoutingValue,
        geoLevelValue:
          domainState.selectedGeoLevel.length === 0
            ? ""
            : domainState.selectedGeoLevel.value,
        domains: domainState.selectedDomainIds,
        excludeEmail:
          expertRecordsState.excludeEmail === true
            ? expertRecordsState.excludeEmail
            : undefined,
        nonCurated:
          expertRecordsState.nonCurated === true
            ? expertRecordsState.nonCurated
            : undefined,
        status: Array.isArray(expertRecordsState.status)
          ? undefined
          : expertRecordsState.status.name,
        rating: Array.isArray(expertRecordsState.rating)
          ? undefined
          : expertRecordsState.rating.name,
        curationCategory:
          expertRecordsState.cc.length === 0
            ? undefined
            : expertRecordsState.cc.map((cc) => cc.name).toString(),
        curationStatus:
          expertRecordsState.cs.length === 0
            ? undefined
            : expertRecordsState.cs.map((cs) => cs.name).toString(),
        express: expertRecordsState.urgent ? true : undefined,
        curatedby: Array.isArray(expertRecordsState.curatedBy)
          ? undefined
          : expertRecordsState.curatedBy,
        updatedFromDate:
          expertRecordsState.curatedFromDate === ""
            ? undefined
            : convertIntoEpoch(expertRecordsState.curatedFromDate, "from"),
        updatedToDate:
          expertRecordsState.curatedToDate === ""
            ? undefined
            : convertIntoEpoch(expertRecordsState.curatedToDate, "to"),
        fromDate:
          expertRecordsState.fromDate === ""
            ? undefined
            : convertIntoEpoch(expertRecordsState.fromDate, "from"),
        tillDate:
          expertRecordsState.tillDate === ""
            ? undefined
            : convertIntoEpoch(expertRecordsState.tillDate, "to"),
        seekers:
          expertRecordsState.seekers.length === 0
            ? undefined
            : expertRecordsState.seekers.map((id) => id.userUuid).toString(),
        experts:
          expertRecordsState.experts.length === 0
            ? undefined
            : expertRecordsState.experts.map((id) => id.userUuid).toString(),
        seekerType: expertRecordsState.seekerType,
        spilled:
          expertRecordsState.spill === true
            ? expertRecordsState.spill
            : undefined,
      };
      if (obj.geoLevelId !== "") {
        if (expertRecordsState.pageNo === 1) {
          getExpertRecordsCount(obj).then((res) => {
            if (res === undefined) return;
            cmrTotalCount(res.data.data / 2);
            getRerouteUser().then((res) => {
              if (res === undefined) return;
              if (res.data.success) {
                let updatedData = res.data.data.users.filter((exp) => {
                  exp.label = exp.firstName + " " + exp.lastName;
                  exp.value = exp.userUuid;
                  return exp;
                });
                cmrExpertsList(updatedData);
              } else {
                cmrUpdatePage(false);
              }
            });
          });
        }

        getExpertrecords(obj).then((res) => {
          if (res === undefined) return;
          cmrUpdateData(res.data.data);
          cmrIsBackFromEmailLink(false);
        });
      }
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  useEffect(() => {
    if (
      !expertRecordsState.isGoBack ||
      expertRecordsState.isBackFromEmailLink
    ) {
      fetchExpertRecordsCount();
    }
  }, [
    domainState.selectedDomainIds,
    domainState.selectedGeoLevel,
    domainState.selecetdRoutingValue,
    expertRecordsState.pageNo,
    expertRecordsState.refresh,
    expertRecordsState.tabsearch,
    expertRecordsState.nonCurated,
    expertRecordsState.excludeEmail,
    expertRecordsState.status,
    expertRecordsState.rating,
    expertRecordsState.cs,
    expertRecordsState.cc,
    expertRecordsState.urgent,
    expertRecordsState.curatedBy,
    expertRecordsState.curatedToDate,
    expertRecordsState.curatedFromDate,
    expertRecordsState.fromDate,
    expertRecordsState.tillDate,
    expertRecordsState.seekers,
    expertRecordsState.experts,
    expertRecordsState.seekerType,
    expertRecordsState.spill,
  ]);

  const onChangeText = (e) => {
    cmrTabSearchData(e.target.value);
  };
  const TabHeadings = (text) => {
    return (
      <span style={{ fontSize: "20px", color: "black" }}>
        {text}
        {!expertRecordsState.isLoading &&
          expertRecordsState.tabsearch === "" && (
            <span>
              {" "}
              {expertRecordsState.totalCount == 0
                ? 0
                : (expertRecordsState.pageNo - 1) * 20 + 1}{" "}
              to{" "}
              {(expertRecordsState.pageNo - 1) * 20 +
                expertRecordsState.data.length}{" "}
              of {expertRecordsState.totalCount * 2}
            </span>
          )}
      </span>
    );
  };

  return (
    <div className="mt-2">
      <Spin spinning={expertRecordsState.isLoading}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            paddingLeft: "10px",
          }}
        >
          <span>
            {
              // TabHeadings("Expert Responses: ")
              TabHeadings(
                `${
                  !expertRecordsState.isLoading &&
                  expertRecordsState.tabsearch === ""
                    ? "Expert Responses:"
                    : "Expert Responses"
                }`,
              )
            }
          </span>

          <div
            style={{ float: "right", display: "flex", alignItems: "center" }}
          >
            {selectedRowKeys.length !== 0 && (
              <>
                {/* <Tooltip
                placement="top"
                color="#fff"
                title={() => (
                  <span style={{ color: "black" }}>Delete Selected</span>
                )}
              >
                <span onClick={() => onCLickDeleteIcon()}>
                  <DeleteIcons
                    style={{ fontSize: "24px", color: "#000000e0", cursor: "pointer", marginTop: '-5px' }}
                  />
                </span>

              </Tooltip> */}
                <span>
                  &nbsp;&nbsp;
                  <TooltipComp title={"Delete Selected"}>
                    <DeleteIcons
                      onClick={() => onCLickDeleteIcon()}
                      style={{
                        fontSize: "24px",
                        color: "#2a364a",
                        cursor: "pointer",
                        fontWeight: "100",
                      }}
                    />
                  </TooltipComp>
                </span>
              </>
            )}
            {selectedRowKeys.length !== 0 && (
              <>
                <span>
                  &nbsp;&nbsp;
                  <TooltipComp title={"Route back to Experts"}>
                    <ShareIcon
                      onClick={() => onCLickRouteBackIcon()}
                      style={{
                        fontSize: "24px",
                        color: "#2a364a",
                        fontWeight: "100",
                        cursor: "pointer",
                      }}
                    />
                  </TooltipComp>
                </span>
              </>
            )}
            {selectedRowKeys.length !== 0 &&
              expertRecordsState.experts.length === 1 &&
              expertRecordsState.status.value === "Answered" && (
                // <span>
                //   &nbsp;&nbsp;
                //   <Tooltip
                //     placement="top"
                //     color="#fff"
                //     title={() => (
                //       <span style={{ color: "black" }}>Transfer Ownership</span>
                //     )}
                //   >
                //     <i className="fa fa-handshake-o" onClick={() => onCLicktransferIcon()}
                //       style={{ color: "#2a364a", cursor: "pointer", marginTop: '-5px', fontSize: "22px" }}
                //     ></i>
                //   </Tooltip>

                // </span>
                <span style={{ marginTop: "2px" }}>
                  &nbsp;&nbsp;
                  <TooltipComp title={"Transfer Ownership"}>
                    <i
                      className="fa fa-handshake-o"
                      onClick={() => onCLicktransferIcon()}
                      style={{
                        color: "#2a364a",
                        cursor: "pointer",
                        fontSize: "18px",
                        marginTop: "4px",
                      }}
                    ></i>
                  </TooltipComp>
                </span>
              )}
            {selectedRowKeys.length === 0 && (
              <span
                onClick={() =>
                  advanceFilterModalToggle({
                    bool: true,
                    value: "cmDataExport",
                  })
                }
                style={{ marginBottom: "5px" }}
              >
                &nbsp;&nbsp;
                <TooltipComp title={"Data Export"}>
                  {/* <UploadIcon  style={{ fontSize: "24px", color: "#2a364a", fontWeight: '100', cursor: "pointer" }} /> */}
                  <img
                    src={uploadImage}
                    width={20}
                    height={19}
                    style={{ cursor: "pointer" }}
                  />
                </TooltipComp>
              </span>
            )}

            {selectedRowKeys.length === 0 && (
              <span>
                &nbsp;&nbsp;
                <TooltipComp title={"Create new QA Pair"}>
                  <PlusOutlined
                    onClick={() => onCLickCreateQAIcon()}
                    style={{
                      fontSize: "18px",
                      color: "#2a364a",
                      cursor: "pointer",
                      marginTop: "-5px",
                    }}
                  />
                </TooltipComp>
              </span>
            )}
            {selectedRowKeys.length === 0 && (
              <span>
                &nbsp;&nbsp;
                <TooltipComp title={"Download"}>
                  <DownloadIcon
                    onClick={() => downloadData()}
                    style={{
                      color: "#2a364a",
                      cursor: "pointer",
                      marginTop: "-5px",
                      fontSize: "1.3rem",
                    }}
                  />
                </TooltipComp>
              </span>
            )}
            {selectedRowKeys.length === 0 && (
              <span onClick={() => cmrRefreshPage("fire")}>
                &nbsp;&nbsp;
                <TooltipComp title={"Refresh"}>
                  <SyncOutlined
                    // style={{ color: "#2a364a", cursor: "pointer", marginTop: '-5px', fontSize: "16px" }
                    // }

                    style={{
                      color: "#2a364a",
                      cursor: "pointer",
                      marginTop: "-5px",
                      fontSize: "1rem",
                    }}
                    spin={expertRecordsState.isLoading}
                  />
                </TooltipComp>
              </span>
            )}
            {selectedRowKeys.length === 0 && (
              <>
                <span onClick={() => showDrawer()}>
                  &nbsp;&nbsp;
                  <TooltipComp title={"Filter List"}>
                    <FilterListIcon
                      style={{
                        color: "#2a364a",
                        cursor: "pointer",
                        marginTop: "-5px",
                        fontSize: "22px",
                      }}
                    />
                  </TooltipComp>
                  {/* <Tooltip placement="top"
                  color="#fff"
                  title={() => <span style={{ color: "black" }}>Filter List</span>}>
                  
                   
                    <FilterListIcon
                      style={{ color: "#2a364a", cursor: "pointer", marginTop: '-5px', fontSize: "22px" }}
                    />
                

                </Tooltip> */}
                </span>
              </>
            )}
          </div>
        </div>
        <div className={Styles.header}>
          <TabSearch
            width={"20%"}
            size="medium"
            value={expertRecordsState.tabsearch}
            onChangeFunc={(e) => onChangeText(e)}
          />

          <div>
            {expertRecordsState.excludeEmail && (
              <span>
                <Tag
                  closeIcon={<CloseCircleOutlined />}
                  style={{
                    fontSize: "12px",
                    fontWeight: "normal",
                    background: "#FFFFFF",
                  }}
                  onClose={() => onClose({ key: "excludeEmail", val: false })}
                >
                  Exclude Email Questions&nbsp;
                </Tag>
              </span>
            )}
            {expertRecordsState.nonCurated && (
              <span>
                <Tag
                  style={{
                    fontSize: "12px",
                    fontWeight: "normal",
                    background: "#FFFFFF",
                  }}
                  closeIcon={<CloseCircleOutlined />}
                  onClose={() => onClose({ key: "nonCurated", val: false })}
                >
                  Last Updated Answers&nbsp;
                </Tag>
              </span>
            )}
            {!Array.isArray(expertRecordsState.status) && (
              <span>
                <Tag
                  closeIcon={<CloseCircleOutlined />}
                  style={{
                    fontSize: "12px",
                    fontWeight: "normal",
                    background: "#FFFFFF",
                  }}
                  onClose={() => onClose({ key: "status", val: false })}
                >
                  Status: {expertRecordsState.status.label}&nbsp;
                </Tag>
              </span>
            )}
            {!Array.isArray(expertRecordsState.rating) && (
              <span>
                <Tag
                  closeIcon={<CloseCircleOutlined />}
                  style={{
                    fontSize: "12px",
                    fontWeight: "normal",
                    background: "#FFFFFF",
                  }}
                  onClose={() => onClose({ key: "rating", val: false })}
                >
                  Rating: {expertRecordsState.rating.label}&nbsp;
                </Tag>
              </span>
            )}
            {expertRecordsState.cc.length > 0 && (
              <span>
                <TooltipComp
                  title={expertRecordsState.cc
                    .map((cc) => cc.label)
                    .sort()
                    .toString()}
                >
                  <Tag
                    closeIcon={<CloseCircleOutlined />}
                    style={{
                      fontSize: "12px",
                      fontWeight: "normal",
                      cursor: "pointer",
                      background: "#FFFFFF",
                    }}
                    onClose={() => onClose({ key: "cc", val: false })}
                  >
                    Curation Category&nbsp;
                  </Tag>
                </TooltipComp>
                {/* <Tooltip
                  placement="top"
                  color="#fff"
                  style={{ fontSize: "12px", fontWeight: "normal", background: "#FFFFFF", }}
                  title={() => (
                    <span style={{ color: "black", fontSize: "12px" }}>
                      {expertRecordsState.cc
                        .map((cc) => cc.label)
                        .sort()
                        .toString()}
                    </span>
                  )}
                >
                  <Tag
                    closeIcon={<CloseCircleOutlined />}
                    style={{
                      fontSize: "12px",
                      fontWeight: "normal",
                      cursor: "pointer",
                    }}
                    onClose={() => onClose({ key: "cc", val: false })}
                  >
                    Curation Category
                  </Tag>
                </Tooltip> */}
              </span>
            )}
            {expertRecordsState.cs.length > 0 && (
              <span>
                <TooltipComp
                  title={expertRecordsState.cs
                    .map((cs) => cs.label)
                    .sort()
                    .toString()}
                >
                  <Tag
                    closeIcon={<CloseCircleOutlined />}
                    style={{
                      fontSize: "12px",
                      fontWeight: "normal",
                      cursor: "pointer",
                      background: "#FFFFFF",
                    }}
                    onClose={() => onClose({ key: "cs", val: false })}
                  >
                    Curation Status&nbsp;
                  </Tag>
                </TooltipComp>
                {/* <Tooltip
                  placement="top"
                  color="#fff"
                  title={() => (
                    <span style={{ color: "black", fontSize: "12px" }}>
                      {expertRecordsState.cs
                        .map((cs) => cs.label)
                        .sort()
                        .toString()}
                    </span>
                  )}
                >
                  <Tag
                    closeIcon={<CloseCircleOutlined />}
                    style={{
                      fontSize: "12px",
                      fontWeight: "normal",
                      cursor: "pointer",
                    }}
                    onClose={() => onClose({ key: "cs", val: false })}
                  >
                    Curation Status
                  </Tag>
                </Tooltip> */}
              </span>
            )}
            {expertRecordsState.urgent && (
              <span>
                <Tag
                  style={{
                    fontSize: "12px",
                    fontWeight: "normal",
                    background: "#FFFFFF",
                  }}
                  closeIcon={<CloseCircleOutlined />}
                  onClose={() => onClose({ key: "urgent", val: false })}
                >
                  Urgent Questions&nbsp;
                </Tag>
              </span>
            )}
            {expertRecordsState.spill && (
              <span>
                <Tag
                  style={{
                    fontSize: "12px",
                    fontWeight: "normal",
                    background: "#FFFFFF",
                  }}
                  closeIcon={<CloseCircleOutlined />}
                  onClose={() => onClose({ key: "spill", val: false })}
                >
                  Expired Questions&nbsp;
                </Tag>
              </span>
            )}
            {expertRecordsState.seekers.length > 0 && (
              <span>
                <TooltipComp
                  title={expertRecordsState.seekers
                    .map((cc) => cc.firstName + " " + cc.lastName)
                    .toString()}
                >
                  <Tag
                    closeIcon={<CloseCircleOutlined />}
                    style={{
                      fontSize: "12px",
                      fontWeight: "normal",
                      cursor: "pointer",
                      background: "#FFFFFF",
                    }}
                    onClose={() => onClose({ key: "seekers", val: false })}
                  >
                    Seeker ID&nbsp;
                  </Tag>
                </TooltipComp>
                {/* <Tooltip
                  placement="top"
                  color="#fff"
                  title={() => (
                    <span style={{ color: "black", fontSize: "12px" }}>
                      {expertRecordsState.seekers
                        .map((cc) => cc.firstName + " " + cc.lastName)
                        .toString()}
                    </span>
                  )}
                >

                </Tooltip> */}
              </span>
            )}
            {expertRecordsState.seekerType !== "" && (
              <span>
                <Tag
                  closeIcon={<CloseCircleOutlined />}
                  style={{
                    fontSize: "12px",
                    fontWeight: "normal",
                    cursor: "pointer",
                    background: "#FFFFFF",
                  }}
                  onClose={() => onClose({ key: "seekerType", val: false })}
                >
                  Seeker Type&nbsp;
                </Tag>
              </span>
            )}
            {expertRecordsState.experts.length > 0 && (
              <span>
                {/* <Tooltip
                  placement="top"
                  color="#fff"
                  title={() => (
                    <span style={{ color: "black", fontSize: "12px" }}>
                      {expertRecordsState.experts
                        .map((cc) => cc.firstName + " " + cc.lastName)
                        .toString()}
                    </span>
                  )}
                >
                  <Tag
                    closeIcon={<CloseCircleOutlined />}
                    style={{
                      fontSize: "12px",
                      fontWeight: "normal",
                      cursor: "pointer",
                    }}
                    onClose={() => onClose({ key: "experts", val: false })}
                  >
                    Experts
                  </Tag>
                </Tooltip> */}
                <TooltipComp
                  title={expertRecordsState?.experts
                    .map((cc) => cc?.firstName + " " + cc?.lastName)
                    .toString()}
                >
                  {/* <Tag
                    closeIcon={<CloseCircleOutlined />}
                    style={{
                      fontSize: "12px",
                      fontWeight: "normal",
                      cursor: "pointer",
                    }}
                    onClose={() => onClose({ key: "experts", val: false })}
                  >
                    Experts
                  </Tag> */}

                  <Tag
                    style={{
                      fontSize: "12px",
                      fontWeight: "normal",
                      background: "#FFFFFF",
                    }}
                    closeIcon={<CloseCircleOutlined />}
                    onClose={() => onClose({ key: "experts", val: false })}
                  >
                    Expert ID&nbsp;
                  </Tag>
                </TooltipComp>
              </span>
            )}
          </div>
        </div>
        <Table
          rowSelection={expertRecordsState.data.length > 0 && rowSelection}
          rowClassName={(record, index) =>
            index % 2 === 0 ? "table-row-light" : "table-row-dark"
          }
          pagination={false}
          rowKey={(record) => record}
          columns={columns}
          dataSource={expertRecordsState.data}
          // loading={expertRecordsState.isLoading}
          style={{ boxShadow: "10px 10px 20px lightgrey" }}
        />
        {expertRecordsState.tabsearch === "" && (
          <div
            className="mb-5"
            style={{
              display: "flex",
              justifyContent: "end",
              borderTop: "1px solid #f0f0f0",
              background: "#fafafa",
              width: "100%",
              paddingBlock: "10px",
              boxShadow: "10px 10px 20px lightgrey",
            }}
          >
            <Pagination
              defaultCurrent={expertRecordsState.pageNo}
              showSizeChanger={false}
              current={expertRecordsState.pageNo}
              total={parseInt(expertRecordsState.totalCount)}
              onChange={(e) => cmrUpdatePageNo(e)}
              disabled={expertRecordsState.isLoading}
            />
          </div>
        )}
      </Spin>
      <Drawer
        // title="Expert records FIlter"
        placement={"right"}
        closable={false}
        onClose={onClose}
        open={open}
        width={"30%"}
      >
        <ExpertRecordsFilters flag={open} onClose={onClose} />
      </Drawer>
    </div>
  );
};
export default ExpertRecordsTable;
